import Form from "antd/lib/form";
import React from "react";

function BaseInput({
  className,
  label,
  name,
  icon,
  prefixClassName,
  textarea,
  placeholder,
  type,
  value,
  inputClassName,
  children,
  suffixClassName,
  rules,
  onEnter,
  ...props
}) {
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && onEnter) {
      event.preventDefault();
      onEnter();
    }
  };

  return (
    <label className={`${className}`}>
      {!!label && <span className="p-xs font-medium text-main">{label}</span>}
      <Form.Item {...{ name }} rules={rules} className="!mb-0" name={name}>
        <div className="relative overflow-hidden rounded-md">
          <div
            className={`absolute pointer-events-none left-5 top-4  ${prefixClassName}`}
          >
            <img src={icon} alt="" />
          </div>
          {textarea ? (
            <textarea
              className={`main-input rounded-md w-full focus:outline-none px-5 py-4 text-main placeholder-[#9797BE] p-sm h-[108px] ${inputClassName}`}
              {...{ placeholder, value, ...props }}
            ></textarea>
          ) : (
            <input
              className={`main-input rounded-md w-full focus:outline-none px-5 py-4 text-main placeholder-[#9797BE] p-sm ${inputClassName}`}
              {...{ placeholder, type, value, ...props }}
              onKeyPress={handleKeyPress}
            />
          )}
          <div
            className={`absolute pointer right-5 bottom-4 flex items-end ${suffixClassName}`}
          >
            {children}
          </div>
        </div>
      </Form.Item>
    </label>
  );
}

export default BaseInput;
